<template>
  <div id="app">
      <router-view></router-view>
    <my-progress/>
  </div>
</template>

<script>


import Progress from '@/components/Progress'
import {downloadProgress} from "@/mixins/downloadProgress";
export default {
  name: 'app',
  components: {
    "my-progress": Progress
  },
}
</script>

<style>
.el-breadcrumb{
  font-size: 15px!important;

}
body{
  min-width: 1350px;
}

</style>
